<p class="product-description">
    {{description || 'No description'}}
  </p>